// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  ChatRequest,
  GenericApiResponse,
  GenericApiResponseChatHistory,
  HTTPValidationError,
  LecturerPreviewFormativeFeedbackRequest,
  StudentEvaluationFeedbackRequest,
} from '../../models';

/**
 * Send a message to the AI Tutor and stream the reply.
 * @summary Chat With Ai Tutor
 */
export const aiTutorChat = (
  courseId: string,
  moduleId: string,
  taskId: string,
  chatRequest: ChatRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.post(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/ai-tutor/chat`, chatRequest, options);
};

export const getAiTutorChatMutationOptions = <
  TData = Awaited<ReturnType<typeof aiTutorChat>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; data: ChatRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['aiTutorChat'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof aiTutorChat>>,
    { courseId: string; moduleId: string; taskId: string; data: ChatRequest }
  > = (props) => {
    const { courseId, moduleId, taskId, data } = props ?? {};

    return aiTutorChat(courseId, moduleId, taskId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; data: ChatRequest },
    TContext
  >;
};

export type AiTutorChatMutationResult = NonNullable<Awaited<ReturnType<typeof aiTutorChat>>>;
export type AiTutorChatMutationBody = ChatRequest;
export type AiTutorChatMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Chat With Ai Tutor
 */
export const useAiTutorChat = <
  TData = Awaited<ReturnType<typeof aiTutorChat>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; data: ChatRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; data: ChatRequest },
  TContext
> => {
  const mutationOptions = getAiTutorChatMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Get recent conversation history for this submission/task.
 * @summary Get Ai Tutor History
 */
export const aiTutorHistory = (
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseChatHistory>> => {
  return axios.get(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/ai-tutor/history`, options);
};

export const getAiTutorHistoryQueryKey = (courseId: string, moduleId: string, taskId: string) => {
  return [`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/ai-tutor/history`] as const;
};

export const getAiTutorHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof aiTutorHistory>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof aiTutorHistory>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAiTutorHistoryQueryKey(courseId, moduleId, taskId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof aiTutorHistory>>> = ({ signal }) =>
    aiTutorHistory(courseId, moduleId, taskId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(courseId && moduleId && taskId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof aiTutorHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AiTutorHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof aiTutorHistory>>>;
export type AiTutorHistoryQueryError = AxiosError<void | HTTPValidationError>;

export function useAiTutorHistory<
  TData = Awaited<ReturnType<typeof aiTutorHistory>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof aiTutorHistory>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof aiTutorHistory>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAiTutorHistory<
  TData = Awaited<ReturnType<typeof aiTutorHistory>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof aiTutorHistory>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof aiTutorHistory>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAiTutorHistory<
  TData = Awaited<ReturnType<typeof aiTutorHistory>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof aiTutorHistory>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Ai Tutor History
 */

export function useAiTutorHistory<
  TData = Awaited<ReturnType<typeof aiTutorHistory>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof aiTutorHistory>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAiTutorHistoryQueryOptions(courseId, moduleId, taskId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Delete all chat history for this submission/task and return empty history.
 * @summary Delete Ai Tutor History
 */
export const aiTutorClearHistory = (
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseChatHistory>> => {
  return axios.delete(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/ai-tutor/history`, options);
};

export const getAiTutorClearHistoryMutationOptions = <
  TData = Awaited<ReturnType<typeof aiTutorClearHistory>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { courseId: string; moduleId: string; taskId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['aiTutorClearHistory'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof aiTutorClearHistory>>,
    { courseId: string; moduleId: string; taskId: string }
  > = (props) => {
    const { courseId, moduleId, taskId } = props ?? {};

    return aiTutorClearHistory(courseId, moduleId, taskId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string },
    TContext
  >;
};

export type AiTutorClearHistoryMutationResult = NonNullable<Awaited<ReturnType<typeof aiTutorClearHistory>>>;

export type AiTutorClearHistoryMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Delete Ai Tutor History
 */
export const useAiTutorClearHistory = <
  TData = Awaited<ReturnType<typeof aiTutorClearHistory>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { courseId: string; moduleId: string; taskId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { courseId: string; moduleId: string; taskId: string }, TContext> => {
  const mutationOptions = getAiTutorClearHistoryMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Trigger a tutor reaction to the most recent evaluation and stream the explanation.
 * @summary React Recent Evaluation
 */
export const aiTutorReactRecentEvaluation = (
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/ai-tutor/reactions/recent-evaluation`,
    undefined,
    options,
  );
};

export const getAiTutorReactRecentEvaluationMutationOptions = <
  TData = Awaited<ReturnType<typeof aiTutorReactRecentEvaluation>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { courseId: string; moduleId: string; taskId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['aiTutorReactRecentEvaluation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof aiTutorReactRecentEvaluation>>,
    { courseId: string; moduleId: string; taskId: string }
  > = (props) => {
    const { courseId, moduleId, taskId } = props ?? {};

    return aiTutorReactRecentEvaluation(courseId, moduleId, taskId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string },
    TContext
  >;
};

export type AiTutorReactRecentEvaluationMutationResult = NonNullable<
  Awaited<ReturnType<typeof aiTutorReactRecentEvaluation>>
>;

export type AiTutorReactRecentEvaluationMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary React Recent Evaluation
 */
export const useAiTutorReactRecentEvaluation = <
  TData = Awaited<ReturnType<typeof aiTutorReactRecentEvaluation>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { courseId: string; moduleId: string; taskId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { courseId: string; moduleId: string; taskId: string }, TContext> => {
  const mutationOptions = getAiTutorReactRecentEvaluationMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Evaluate submission using rubric; streams per-dimension progress then formative feedback.
 * @summary Evaluate Single Submission
 */
export const getAiTutorEvaluation = (
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.post(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/ai-tutor/evaluation`, undefined, options);
};

export const getGetAiTutorEvaluationMutationOptions = <
  TData = Awaited<ReturnType<typeof getAiTutorEvaluation>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { courseId: string; moduleId: string; taskId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['getAiTutorEvaluation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAiTutorEvaluation>>,
    { courseId: string; moduleId: string; taskId: string }
  > = (props) => {
    const { courseId, moduleId, taskId } = props ?? {};

    return getAiTutorEvaluation(courseId, moduleId, taskId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string },
    TContext
  >;
};

export type GetAiTutorEvaluationMutationResult = NonNullable<Awaited<ReturnType<typeof getAiTutorEvaluation>>>;

export type GetAiTutorEvaluationMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Evaluate Single Submission
 */
export const useGetAiTutorEvaluation = <
  TData = Awaited<ReturnType<typeof getAiTutorEvaluation>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { courseId: string; moduleId: string; taskId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { courseId: string; moduleId: string; taskId: string }, TContext> => {
  const mutationOptions = getGetAiTutorEvaluationMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Submit student feedback on an AI Tutor evaluation.
 * @summary Submit Evaluation Feedback
 */
export const submitAiTutorEvaluationFeedback = (
  courseId: string,
  moduleId: string,
  taskId: string,
  studentEvaluationFeedbackRequest: StudentEvaluationFeedbackRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/ai-tutor/evaluation/feedback`,
    studentEvaluationFeedbackRequest,
    options,
  );
};

export const getSubmitAiTutorEvaluationFeedbackMutationOptions = <
  TData = Awaited<ReturnType<typeof submitAiTutorEvaluationFeedback>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; data: StudentEvaluationFeedbackRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['submitAiTutorEvaluationFeedback'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitAiTutorEvaluationFeedback>>,
    { courseId: string; moduleId: string; taskId: string; data: StudentEvaluationFeedbackRequest }
  > = (props) => {
    const { courseId, moduleId, taskId, data } = props ?? {};

    return submitAiTutorEvaluationFeedback(courseId, moduleId, taskId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; data: StudentEvaluationFeedbackRequest },
    TContext
  >;
};

export type SubmitAiTutorEvaluationFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitAiTutorEvaluationFeedback>>
>;
export type SubmitAiTutorEvaluationFeedbackMutationBody = StudentEvaluationFeedbackRequest;
export type SubmitAiTutorEvaluationFeedbackMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Submit Evaluation Feedback
 */
export const useSubmitAiTutorEvaluationFeedback = <
  TData = Awaited<ReturnType<typeof submitAiTutorEvaluationFeedback>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; data: StudentEvaluationFeedbackRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; data: StudentEvaluationFeedbackRequest },
  TContext
> => {
  const mutationOptions = getSubmitAiTutorEvaluationFeedbackMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Run AI Tutor evaluation + formative feedback on an ephemeral lecturer draft (SSE stream).
 * @summary Preview Formative Feedback
 */
export const getLecturerAiTutorPreviewFormativeFeedback = (
  moduleId: string,
  version: string,
  taskId: string,
  lecturerPreviewFormativeFeedbackRequest: LecturerPreviewFormativeFeedbackRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.post(
    `/modules/${moduleId}/versions/${version}/tasks/${taskId}/ai-tutor/preview-formative-feedback`,
    lecturerPreviewFormativeFeedbackRequest,
    options,
  );
};

export const getGetLecturerAiTutorPreviewFormativeFeedbackMutationOptions = <
  TData = Awaited<ReturnType<typeof getLecturerAiTutorPreviewFormativeFeedback>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: LecturerPreviewFormativeFeedbackRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['getLecturerAiTutorPreviewFormativeFeedback'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getLecturerAiTutorPreviewFormativeFeedback>>,
    { moduleId: string; version: string; taskId: string; data: LecturerPreviewFormativeFeedbackRequest }
  > = (props) => {
    const { moduleId, version, taskId, data } = props ?? {};

    return getLecturerAiTutorPreviewFormativeFeedback(moduleId, version, taskId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: LecturerPreviewFormativeFeedbackRequest },
    TContext
  >;
};

export type GetLecturerAiTutorPreviewFormativeFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof getLecturerAiTutorPreviewFormativeFeedback>>
>;
export type GetLecturerAiTutorPreviewFormativeFeedbackMutationBody = LecturerPreviewFormativeFeedbackRequest;
export type GetLecturerAiTutorPreviewFormativeFeedbackMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Preview Formative Feedback
 */
export const useGetLecturerAiTutorPreviewFormativeFeedback = <
  TData = Awaited<ReturnType<typeof getLecturerAiTutorPreviewFormativeFeedback>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: LecturerPreviewFormativeFeedbackRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; version: string; taskId: string; data: LecturerPreviewFormativeFeedbackRequest },
  TContext
> => {
  const mutationOptions = getGetLecturerAiTutorPreviewFormativeFeedbackMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Alias for preview_formative_feedback (SSE).
 * @summary Preview Formative Feedback Stream
 */
export const streamLecturerAiTutorPreviewFormativeFeedback = (
  moduleId: string,
  version: string,
  taskId: string,
  lecturerPreviewFormativeFeedbackRequest: LecturerPreviewFormativeFeedbackRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.post(
    `/modules/${moduleId}/versions/${version}/tasks/${taskId}/ai-tutor/preview-formative-feedback/stream`,
    lecturerPreviewFormativeFeedbackRequest,
    options,
  );
};

export const getStreamLecturerAiTutorPreviewFormativeFeedbackMutationOptions = <
  TData = Awaited<ReturnType<typeof streamLecturerAiTutorPreviewFormativeFeedback>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: LecturerPreviewFormativeFeedbackRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['streamLecturerAiTutorPreviewFormativeFeedback'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof streamLecturerAiTutorPreviewFormativeFeedback>>,
    { moduleId: string; version: string; taskId: string; data: LecturerPreviewFormativeFeedbackRequest }
  > = (props) => {
    const { moduleId, version, taskId, data } = props ?? {};

    return streamLecturerAiTutorPreviewFormativeFeedback(moduleId, version, taskId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: LecturerPreviewFormativeFeedbackRequest },
    TContext
  >;
};

export type StreamLecturerAiTutorPreviewFormativeFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof streamLecturerAiTutorPreviewFormativeFeedback>>
>;
export type StreamLecturerAiTutorPreviewFormativeFeedbackMutationBody = LecturerPreviewFormativeFeedbackRequest;
export type StreamLecturerAiTutorPreviewFormativeFeedbackMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Preview Formative Feedback Stream
 */
export const useStreamLecturerAiTutorPreviewFormativeFeedback = <
  TData = Awaited<ReturnType<typeof streamLecturerAiTutorPreviewFormativeFeedback>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: LecturerPreviewFormativeFeedbackRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; version: string; taskId: string; data: LecturerPreviewFormativeFeedbackRequest },
  TContext
> => {
  const mutationOptions = getStreamLecturerAiTutorPreviewFormativeFeedbackMutationOptions(options);

  return useMutation(mutationOptions);
};
